import React, { useCallback, useEffect } from "react"

import TextButton from "@components/TextButton"
import { useGiftRegistryContext } from "@app/providers/giftRegistry"
import useProductQuickView from "@hooks/useProductQuickView"
import { Box } from "@chakra-ui/react"

export interface ProductWishlistProps {
  product: any
  collection: boolean
}

const ProductGiftRegistry = ({ product, collection }) => {
  const { setVal } = useGiftRegistryContext()
  const { onClose } = useProductQuickView()

  return (
    <Box
      onClick={() => {
        setVal("drawers.addToRegistry", true)
        collection ? onClose() : null
      }}
    >
      <TextButton size="m" py={1} icon="registry" iconSize="23px" iconPlacement="left" color="text.primary" iconSpacing={1}>
        Add to Registry
      </TextButton>
    </Box>
  )
}

export default React.memo(ProductGiftRegistry)
